import React, { useEffect, useState } from 'react'
import { useLazyGetContactQuery } from '../../../../contact-us/redux/ContactUsApi'
import { AuctionResponse } from '../../../types';

interface Props {
    item?: AuctionResponse,
}

const TabContent2 = ({ item }: Props) => {
    const [contactTrigger, contactResponse] = useLazyGetContactQuery();
    const [seeMore, setSeeMore] = useState(false);

    useEffect(() => {
        contactTrigger({ type: 0 })
    }, [contactTrigger])

    return (
        <div>
            <div style={{ maxHeight: seeMore ? '100%' : '545px', overflow: 'hidden' }}>
                <h3 style={{ fontWeight: 'bold', textDecoration: 'underline' }}>TỔ CHỨC ĐẤU GIÁ</h3>
                <p style={{ textTransform: 'uppercase', marginTop: 20 }}>{contactResponse.data?.content[0]?.title || ""}</p>
                <p>Số điện thoại: {contactResponse.data?.content[0]?.mobile || ""}</p>
                <p>Email: {contactResponse.data?.content[0]?.email || ""}</p>
                <p>Địa chỉ: {contactResponse.data?.content[0]?.address || ""}</p>

                <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', marginTop: 30 }}>NGƯỜI CÓ TÀI SẢN</h3>
                <p style={{ textTransform: 'uppercase', marginTop: 20 }}>{item?.seller.fullName || ""}</p>
                <p>Địa chỉ: {item?.seller.address || ""}</p>
            </div>

            {
                !seeMore && <div className="see-more" onClick={() => setSeeMore(true)}>
                    Xem thêm
                </div>
            }
        </div >
    )
}

export default TabContent2